import { isOpen } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

/** `isOpen` rather than `isAvailable`: a payload without the CustomIndustryBuilder component carries no
 *  availability mode, and `isAvailable` reads that as open — the agentic builder stays closed instead. */
export const isCustomIndustryBuilderAvailable = (): boolean => isOpen(swSettings.components.CustomIndustryBuilder);
